import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import { Button, Icon, Confirm } from 'semantic-ui-react';
import { ConfirmDialog } from 'primereact/confirmdialog'; // For <ConfirmDialog /> component
import { confirmDialog } from 'primereact/confirmdialog'; // For confirmDialog method

import { onMessage, unSubChannel } from 'shared/services/Pusher';

import {
  createPaymentIntent,
  processPaymentIntent,
  cancelStripeReader,
  updateReaderStatus,
} from 'shared/actions/stripeActions';

import {
  createPayment as createPaymentTilby,
  initWebhook as initWebhookTilby,
} from 'shared/actions/tilbyActions';

import {
  createPurchaseRequest,
  setPurchased,
  addPurchase,
  getPurchasedMomentIds,
  getPurchaseCalculations
} from 'shared/actions/cartActions';

import {
  getStore
} from 'shared/services/Store';

import {
  viewReceipt,
  setEmail,
  authorizePin,
  me
} from 'app/actions/kioskActions';

import {
  getCurrencySign,
  renderPurchaseDescriptionStatic
} from 'shared/services/PriceService';

import {
  downloadMomentBlob,
  downloadPrintOrder
} from 'shared/services/DownloadService'

import {
  getSelectedCalculations,
  getCombinedSelectedMomentIds
} from 'shared/selectors/cartSelectors';

import {
  MULTI_PRINT_MODE,
  SIZED_PRINT_MODE,
  TILBY_CASHREGISTER_URL
} from 'shared/utils/Constants';

import {
  CLUBMED_THEME,
  HPX_THEME
} from 'shared/config/themes';

import PurchaseDetails from 'app/components/PurchaseDetails';
import StripeForm from 'shared/components/StripeForm';
import PurchaseService from 'shared/services/PurchaseService';
import Modal from 'app/components/Modal';
import modalStyles from 'shared/components/modalStyles';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';
import config from 'shared/config/config';

import {
  HAGGLE_CHECKOUT_TYPE,
  MARKETPLACE_CHECKOUT_TYPE,
  KIOSK_PRICING_CHECKOUT_TYPE,
  STRIPE_PAYMENT_METHOD,
  TILBY_PAYMENT_METHOD,
  OFFSITE_POS_PAYMENT_METHOD,
  STRIPE_READER_PAYMENT_METHOD,
  GENERIC_OFFSITE_POS_TYPE,
  BILL_TO_ROOM_OFFSITE_POS_TYPE
} from 'app/utils/Constants';

import {
  getSelectedPrintMoments
} from 'shared/selectors/cartSelectors';
import { promised } from 'q';

const styles = () => ({
  orderButtonWrapper: {
    float: 'left',
    width: '100%',
    padding: '5px 0 5px 5px'
  },
  button: {
    float: 'left',
    width: '100%',
    textAlign: 'center',
    padding: '0.5rem 1.3rem',
    fontWeight: 600,
    background: 'linear-gradient(#4ea4c3, #007aa1)',
    borderRadius: '3px',
    border: 'none',
    color: '#fff'
  },
  secondButton: {
    float: 'left',
    width: '100%',
    textAlign: 'center',
    padding: '0.5rem 1.3rem',
    fontWeight: 600,
    background: 'linear-gradient(#ffffff, #f1f1f1)',
    borderRadius: '3px',
    border: '1px solid #dcdcdc',
    boxShadow: '0 0 2px #dcdcdc',
    color: '#2b8eb0'
  },
  label: {
    float: 'left',
    fontWeight: 600,
    fontFamily: config.sub_font
  },
  input: {
    width: '100%',
    fontSize: '1.1rem',
    padding: '0.7655rem',
    borderRadius: '5px',
    border: '1px solid #aaa',
    fontFamily: config.sub_font
  },
  formGroup: {
    marginBottom: '0.8rem'
  },
  inputGroup: {
    padding: '0.3rem 0'
  },
  checkboxGroup: {
    display: 'inline-block',
    width: '100%',
    height: '2rem',
    padding: '0.3rem 0'
  },
  completePurchaseButton: {
    float: 'right',
    textAlign: 'center',
    padding: '0.5rem 1.3rem',
    fontWeight: 600,
    background: 'linear-gradient(#4ea4c3, #007aa1)',
    borderRadius: '3px',
    border: 'none',
    color: '#fff',
    fontSize: '16px',
    fontFamily: config.root_font_family
  },
  completePurchaseButton2: {
    float: 'right',
    textAlign: 'center',
    padding: '0.5rem 1.3rem',
    fontWeight: 600,
    background: '#3A8DDE',
    borderRadius: '3px',
    border: 'none',
    color: '#fff',
    marginTop: '0.4rem'
  },
  selectionContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gap: '10px'
  },
  ...modalStyles()
});

const initialState = {
  showEmail: false,
  sendingEmail: false,
  showComplete: false,
  selectedPaymentMethod: STRIPE_PAYMENT_METHOD,
  error: null,
  pin: null,
  hagglePrice: null,
}

class PurchaseModal extends React.Component {
  constructor(props) {
    super(props);

    this.customerName = createRef();
    this.emailInput = createRef();
    this.purchaseEmail = createRef();
    this.purchaseButton = createRef();
    this.pinInput = createRef();
    this.hagglePriceInput = createRef();
    this.unlockCheckbox = createRef();
    this.approveButton = createRef();
    this.store = getStore();

    this.selectedKioskPricing = {};

    this.state = {
      ...initialState
    }
  }

  onClose() {
    const { connectionStatus } = this.props;
    if (connectionStatus === "Processing") {
      this.cancelPayment();
    }
    this.setState({ ...initialState });
    this.props.onClose();
  }

  async stripeCallback(purchase) {
    let momentIds = this.props.combinedSelectedMomentIds;

    // download prints if multi print mode
    this.downloadPrints(purchase.id);

    this.props.setEmail(purchase.email);
    this.props.setPurchased(momentIds);
    this.onClose();

    const { purchaseRequest, me, settings, user } = this.props;

    // refresh user to get unlocked state if changed
    if (purchaseRequest && purchaseRequest.unlock_all) {
      await me(settings.token)
    }

    // refresh purchase calculations for purchase stacking
    this.refreshPurchaseCalculations();

    setTimeout(() => {
      this.props.viewReceipt();
    }, 500);
  }

  async refreshPurchaseCalculations() {
    const { user, getPurchaseCalculations } = this.props;
    const { moments } = this.store;

    let maxQuantity = moments.allIds.length;

    // Pull moments from Redux if not stored in window
    if (maxQuantity == 0) {
      maxQuantity = this.props.moments.allIds.length;
    }

    return await getPurchaseCalculations(user.story_id, maxQuantity);
  }

  async downloadPrints(purchaseId) {
    const { settings, prints } = this.props;

    if (settings.print_mode === MULTI_PRINT_MODE && !settings.drive_printing) {
      for (let print of prints) {
        downloadMomentBlob(print);
      }
    } else if (settings.print_mode === SIZED_PRINT_MODE) {
      if (prints.length > 0) {
        downloadPrintOrder(purchaseId);
      }
    }
  }

  async selectStripeCheckout() {
    this.setState({
      selectedPaymentMethod: STRIPE_PAYMENT_METHOD,
      error: null
    });
  }

  async selectTilbyCheckout() {
    this.setState({
      selectedPaymentMethod: TILBY_PAYMENT_METHOD,
      error: null
    });
  }

  async selectStripeReaderCheckout() {
    this.setState({
      selectedPaymentMethod: STRIPE_READER_PAYMENT_METHOD,
      error: null
    });
  }

  async selectOffsitePosCheckout() {
    this.setState({
      selectedPaymentMethod: OFFSITE_POS_PAYMENT_METHOD,
      error: null
    });
  }

  async authorizePin() {
    const { settings, authorizePin } = this.props;
    let pin = this.pinInput.current.value;

    try {
      await authorizePin(settings.account_id, pin);
      this.setState({ pin });

    } catch (err) {
      console.error(err);
      throw 'Invalid pin';
    }
  }

  async selectKioskPricing(pricing) {
    const {
      settings,
      moments,
      selectedMomentIds,
      selectedPrintMomentIds,
      createPurchaseRequest,
    } = this.props;

    this.selectedKioskPricing = pricing;

    const unlockCheckbox = this.unlockCheckbox.current;

    let pin = this.state.pin;
    let hagglePrice = pricing.store_price * 100;
    let unlockAll = !!unlockCheckbox && unlockCheckbox.checked;
    let momentCount = selectedMomentIds.filter(id => moments.byId[id] && moments.byId[id].premium).length;
    let printCount = selectedPrintMomentIds.filter(id => moments.byId[id] && moments.byId[id].premium).length;

    await createPurchaseRequest(settings.token, {
      pin: pin,
      amount: hagglePrice || 0,
      unlock_all: unlockAll,
      moment_count: momentCount,
      print_count: printCount,
      kiosk_id: settings.kiosk_id
    });
  }

  async approveHaggle() {
    const {
      settings,
      moments,
      selectedMomentIds,
      selectedPrintMomentIds,
      createPurchaseRequest,
    } = this.props;

    const unlockCheckbox = this.unlockCheckbox.current;

    let pin = this.state.pin;
    let cents = parseFloat(this.hagglePriceInput.current.value) * 100;
    let hagglePrice = parseInt(cents.toFixed(0));
    let unlockAll = !!unlockCheckbox && unlockCheckbox.checked;
    let momentCount = selectedMomentIds.filter(id => moments.byId[id] && moments.byId[id].premium).length;
    let printCount = selectedPrintMomentIds.filter(id => moments.byId[id] && moments.byId[id].premium).length;

    await createPurchaseRequest(settings.token, {
      pin: pin,
      amount: hagglePrice || 0,
      unlock_all: unlockAll,
      moment_count: momentCount,
      print_count: printCount,
      kiosk_id: settings.kiosk_id
    });
  }

  async processTilby() {
    const { calculations,
      createPaymentTilby,
      initWebhookTilby,
      purchaseRequest,
      settings
    } = this.props;

    let email = this.purchaseEmail.current.value;
    let name = this.customerName.current?.value;

    if (!email) {
      this.setState({ error: "Please enter an email address." });
      return;
    }

    if (settings.set_mandatory_customer_name && !name) {
      this.setState({ error: "Please enter the customer name." });
      return;
    }

    if (settings.enable_email_verification) {
      if (window.confirm(`Please confirm your email address is correct: ${this.props.email}. Click OK to continue or Cancel to change it.`) === false) {
        return;
      }
    }

    // may or may not exist
    let purchaseRequestId = purchaseRequest && purchaseRequest.id;

    let finalPrice = 0;
    let item_id = "";
    let item_name = "";

    if (this.selectedKioskPricing) {
      item_id = this.selectedKioskPricing.package_id;
      item_name = this.selectedKioskPricing.description;
    }

    switch (settings.checkout_type) {
      case HAGGLE_CHECKOUT_TYPE:
      case KIOSK_PRICING_CHECKOUT_TYPE:
        if (purchaseRequest) {
          finalPrice = (purchaseRequest.amount === 0) ? 0 : purchaseRequest.amount;
        }
        break;

      case MARKETPLACE_CHECKOUT_TYPE:
        if (calculations) {
          finalPrice = (calculations.total === 0) ? 0 : calculations.total;
        }
    }

    let createParams = {
      price: finalPrice,
      quantity: 1, // Fixed to 1, to prevent autocalculation in tilby
      requestId: purchaseRequestId, // this is OK regardless it has value or not.
      currency: settings.currency,
      email: email,
      customer_name: name,
      item_id: item_id,
      item_name: item_name,
    }

    // Initialize tilby webhook
    initWebhookTilby(settings.account_id).then(data => {
      console.log("initWebhookTilby success: ", data);
    }).catch(error => {
      // Ignore if already created
    });

    this.setState({ tilbyStatus: 'PROCESSING' });

    createPaymentTilby(settings.account_id, createParams).then(sale => {
      // Initialize the webhook that will can be tilby will to server
      window.open(TILBY_CASHREGISTER_URL(sale.id), "_blank", "noreferrer");

      // Listen to tilby webhook
      onMessage("tilby-status", "purchase", "complete", msg => {
        msg.message.entities.forEach(entity => {
          if (entity.uuid == sale.uuid) {
            this.onTilbyPurchaseComplete(entity.id);
            return;
          }
        })
      });
    }).catch(err => {
      // Set failed
      this.setState({ error: err.error, tilbyStatus: 'FAILED' });
    });
  }

  async onTilbyPurchaseComplete(saleId) {
    const { settings,
      user,
      selectedMomentIds,
      selectedPrintMomentIds,
      purchaseRequest,
      calculations,
    } = this.props;

    let description = this.getPurchaseDescription();
    let email = this.purchaseEmail.current.value;
    let customerName = this.customerName.current?.value;

    let freeMode = false;
    switch (settings.checkout_type) {
      case HAGGLE_CHECKOUT_TYPE:
      case KIOSK_PRICING_CHECKOUT_TYPE:
        freeMode = purchaseRequest && purchaseRequest.amount === 0;
        break;

      case MARKETPLACE_CHECKOUT_TYPE:
        freeMode = calculations && calculations.total === 0;
    }

    let params = {
      email,
      customer_name: customerName,
      receivable: true,
      moment_ids: selectedMomentIds,
      account_id: settings.account_id,
      kiosk_token: settings.token,
      story_id: user.story_id,
      print_moment_ids: selectedPrintMomentIds,
      pin: this.state.pin,
      tilby_sale_id: saleId,
      coupon_code: calculations?.discount_coupon_code,
      description
    }

    if (purchaseRequest && purchaseRequest.id) {
      params.purchase_request_id = purchaseRequest.id;
    }

    PurchaseService.purchase(params).then(async (purchase) => {
      this.props.addPurchase(purchase);
      this.setState({ tilbyStatus: 'SUCCESS' });
      unSubChannel("tilby-status");
      await this.stripeCallback(purchase);
    })

  }

  async processPayment() {
    const {
      calculations,
      settings,
      defaultStripeReader,
      purchaseRequest,
      createPaymentIntent,
      processPaymentIntent,
      updateReaderStatus
    } = this.props;

    let total = calculations.total;
    let purchaseRequestId = purchaseRequest && purchaseRequest.id;
    let email = this.purchaseEmail.current.value;
    let name = this.customerName.current?.value;

    if (!email) {
      this.setState({ error: "Please enter an email address." });
      return;
    }

    if (settings.set_mandatory_customer_name && !name) {
      this.setState({ error: "Please enter the customer name." });
      return;
    }

    if (settings.enable_email_verification) {
      if (window.confirm(`Please confirm your email address is correct: ${this.props.email}. Click OK to continue or Cancel to change it.`) === false) {
        return;
      }
    }

    // Clear any previous error if we got here
    if (this.state.error) {
      this.setState({ error: null });
    }

    if (purchaseRequestId) {
      total = purchaseRequest.amount;
    }

    let freeMode = total == 0;

    if (freeMode) {
      this.createStripeReaderPurchase('', purchaseRequestId, '');
      return;
    }

    if (email) {
      if (defaultStripeReader && defaultStripeReader.stripe_reader_id) {
        onMessage("reader-status", "purchase", "complete", msg => this.onPurchaseComplete(msg.reader));

        updateReaderStatus("Processing");
        createPaymentIntent(settings.account_id, { amount: total, currency: settings.currency }).then((paymentData) => {
          processPaymentIntent(settings.account_id, { payment_intent: paymentData.payment_intent, reader_id: defaultStripeReader.stripe_reader_id }).then((result) => {
            if (result.error) {
              updateReaderStatus("Payment Failed");
              unSubChannel("reader-status");
            }
          }).catch(error => {
            updateReaderStatus("Payment Failed");
            unSubChannel("reader-status");
          });
        }).catch(error => {
          updateReaderStatus("Payment Failed");
          unSubChannel("reader-status");
        });
      } else {
        updateReaderStatus("Not Connected");
        unSubChannel("reader-status");
      }
    }
  }

  async cancelPayment() {
    const { settings, terminalPaymentData, cancelStripeReader, updateReaderStatus, defaultStripeReader } = this.props;

    if (!terminalPaymentData) {
      return;
    }

    cancelStripeReader(settings.account_id, { payment_intent: terminalPaymentData.payment_intent, reader_id: defaultStripeReader.stripe_reader_id }).then((resp) => {
      updateReaderStatus("Connected to reader");
      unSubChannel("reader-status");
    })
  }

  onPurchaseComplete(reader) {
    const { settings, defaultStripeReader, purchaseRequest, updateReaderStatus } = this.props;

    if (reader.id === defaultStripeReader.stripe_reader_id) {
      if (reader.action.status === "succeeded") {
        let purchaseRequestId = purchaseRequest && purchaseRequest.id;

        this.createStripeReaderPurchase(reader.action.process_payment_intent.payment_intent.id, purchaseRequestId);
      } else {
        updateReaderStatus("Payment Failed");
        unSubChannel("reader-status");
      }
    }
  }

  async createStripeReaderPurchase(paymentIntentId, purchaseRequestId) {
    const {
      settings,
      user,
      selectedMomentIds,
      selectedPrintMomentIds,
      updateReaderStatus,
      calculations
    } = this.props;

    let description = this.getPurchaseDescription();
    let email = this.purchaseEmail.current.value;
    let name = this.customerName.current?.value;

    let params = {
      email,
      customer_name: name,
      moment_ids: selectedMomentIds,
      account_id: settings.account_id,
      kiosk_token: settings.token,
      story_id: user.story_id,
      print_moment_ids: selectedPrintMomentIds,
      pin: this.state.pin,
      reader_purchase: true,
      coupon_code: calculations?.discount_coupon_code,
      description
    }

    if (paymentIntentId) {
      params.payment_intent_id = paymentIntentId;
    }

    if (purchaseRequestId) {
      params.purchase_request_id = purchaseRequestId;
    }

    PurchaseService.purchase(params).then(async (purchase) => {
      this.props.addPurchase(purchase);
      updateReaderStatus("Connected to reader");
      unSubChannel("reader-status");
      await this.stripeCallback(purchase);
    })
  }

  async createOffsitePosPurchase() {
    const {
      settings,
      user,
      selectedMomentIds,
      selectedPrintMomentIds,
      purchaseRequest,
      calculations
    } = this.props;

    let email = this.purchaseEmail.current.value;
    let name = this.customerName.current?.value;
    let description = this.getPurchaseDescription();

    if (!email) {
      this.setState({ error: "Please enter an email address." });
      return;
    }

    if (settings.set_mandatory_customer_name && !name) {
      this.setState({ error: "Please enter the customer name." });
      return;
    }

    if (settings.enable_email_verification) {
      if (window.confirm(`Please confirm your email address is correct: ${this.props.email}. Click OK to continue or Cancel to change it.`) === false) {
        return;
      }
    }

    let params = {
      receivable: true,
      email,
      customer_name: name,
      moment_ids: selectedMomentIds,
      account_id: settings.account_id,
      kiosk_token: settings.token,
      story_id: user.story_id,
      print_moment_ids: selectedPrintMomentIds,
      coupon_code: calculations?.discount_coupon_code,
      description
    }

    if (purchaseRequest && purchaseRequest.id) {
      params.purchase_request_id = purchaseRequest.id;
    }

    let purchase = await PurchaseService.purchase(params);

    // the PaymentForm component normally adds the purchase to Redux
    // after performing the purchase API call.
    // we're not using that component so add the purchase here instead
    this.props.addPurchase(purchase);

    await this.stripeCallback(purchase);
  }

  getPurchaseDescription() {
    const {
      settings,
      selectedMomentIds,
      selectedPrintMomentIds,
      purchaseRequest,
      locale,
      messages: compiledMessages
    } = this.props;

    let digitals = selectedMomentIds.length;
    let prints = selectedPrintMomentIds.length;
    let unlockAll = purchaseRequest && purchaseRequest.unlock_all;
    let printsEnabled = settings.prints_enabled;

    if (digitals || prints) {
      return renderPurchaseDescriptionStatic(locale, compiledMessages, digitals, prints, unlockAll, printsEnabled);
    }
    return '';
  }

  renderOffsitePosCheckoutSlide() {
    const {
      classes,
      settings
    } = this.props;

    let header, msg;
    switch (settings.offsite_pos_type) {
      case BILL_TO_ROOM_OFFSITE_POS_TYPE:
        header = messages.kiosk_offsite_pos_form_bill_to_room_header
        msg = messages.kiosk_offsite_pos_form_bill_to_room_instructions;
        break;

      case GENERIC_OFFSITE_POS_TYPE:
      default:
        header = messages.kiosk_offsite_pos_form_generic_header;
        msg = messages.kiosk_offsite_pos_form_generic_instructions;
    }

    let uppercase = settings.theme === HPX_THEME;

    let error = null;
    if (this.state.error) {
      error = (
        <p className={classes.modalText} style={{ textAlign: 'left', margin: '0.8rem 0', fontSize: '1rem', color: 'red' }}>
          {this.state.error}
        </p>
      );
    }

    let slide = {};

    slide.component = (
      <div>
        <p className={classes.modalHeader}>
          <FormattedMessage {...withValues(header, { uppercase })} />
        </p>
        <p className={classes.modalText} style={{ textAlign: 'left', margin: '0.8rem 0', fontSize: '1rem' }}>
          <FormattedMessage {...msg} />
        </p>
        <PurchaseDetails hideHeader={true} />
        <div className={classes.inputGroup}>
          <label className={classes.label} for="email">
            <FormattedMessage {...messages.form_label_email_address} />
          </label>
          <input ref={this.purchaseEmail} className={classes.input} style={{ marginBottom: '1rem' }} type="email" name="email" defaultValue={this.props.email} />
        </div>
        <div className={classes.inputGroup}>
          {
            settings.set_mandatory_customer_name &&
            <div>
              <label className={classes.label} for="name">
                <FormattedMessage {...messages.form_label_customers_name} />
              </label>
              <input ref={this.customerName} className={classes.input} style={{ marginBottom: '1rem' }} type="text" name="name" defaultValue={this.props.user.name} />
            </div>
          }
          {error}
        </div>
      </div>
    );

    slide.nextLabel = <FormattedMessage {...messages.button_purchase} />;
    slide.onNext = () => this.createOffsitePosPurchase();
    slide.prevLabel = <FormattedMessage {...messages.button_back} />;
    slide.skipClose = true;

    return slide;
  }

  renderStripeReaderSlide() {
    const {
      classes,
      settings,
      selectedMomentIds,
      purchaseRequest,
      connectionStatus,
      calculations,
      defaultStripeReader
    } = this.props;

    let total = 0;
    if (calculations) {
      total = calculations.total;
    }

    let purchaseRequestId = purchaseRequest && purchaseRequest.id;

    if (purchaseRequestId) {
      total = purchaseRequest.amount;
    }

    let freeMode = total == 0;

    let slide = {};
    let header, buttonsStyle = null;;
    if (settings.theme === CLUBMED_THEME) {
      header = messages.kiosk_stripe_form_header_clubmed;
      buttonsStyle = {
        marginTop: '1rem'
      }
    } else {
      header = messages.kiosk_stripe_form_header;
    }

    let msg;
    if (selectedMomentIds.length === 1) {
      msg = 'This image will be provided free of charge.';
    } else {
      msg = 'These images will be provided free of charge.';
    }

    let error = null;
    if (this.state.error) {
      error = (
        <p className={classes.modalText} style={{ textAlign: 'left', margin: '0.8rem 0', fontSize: '1rem', color: 'red' }}>
          {this.state.error}
        </p>
      );
    }

    let uppercase = settings.theme === HPX_THEME;
    slide.component = (
      <div>
        <p className={classes.modalHeader}>
          <FormattedMessage {...withValues(header, { uppercase })} />
        </p>
        <div style={{ margin: '0.5rem 0' }}>
          <PurchaseDetails condensed={true} hideHeader={true} />
        </div>
        {
          freeMode &&
          <p className={classes.modalText}>
            {msg}
          </p>
        }
        {
          !freeMode && connectionStatus === 'Not Connected' &&
          <p className={classes.modalText}>
            <FormattedMessage {...withValues(messages.kiosk_reader_not_connected)} />
          </p>
        }
        {
          !freeMode && connectionStatus === 'Connected to reader' &&
          <p className={classes.modalText}>
            <FormattedMessage {...withValues(messages.kiosk_reader_standby)} />
          </p>
        }
        {
          !freeMode && connectionStatus === 'Processing' &&
          <p className={classes.modalText}>
            <FormattedMessage {...withValues(messages.kiosk_processing_payment)} />
          </p>
        }
        {
          !freeMode && connectionStatus === 'Payment Failed' &&
          <p className={classes.modalText}>
            <FormattedMessage {...withValues(messages.kiosk_reader_payment_failed)} />
          </p>
        }
        <div className={classes.inputGroup}>
          <label className={classes.label} for="email">
            <FormattedMessage {...messages.form_label_email_address} />
          </label>
          <input ref={this.purchaseEmail} className={classes.input} style={{ marginBottom: '1rem' }} type="email" name="email" defaultValue={this.props.email} />
        </div>
        <div className={classes.inputGroup}>
          {
            settings.set_mandatory_customer_name &&
            <div>
              <label className={classes.label} for="name">
                <FormattedMessage {...messages.form_label_customers_name} />
              </label>
              <input ref={this.customerName} className={classes.input} style={{ marginBottom: '1rem' }} type="text" name="name" defaultValue={this.props.user.name} />
            </div>
          }
          {error}
        </div>
      </div>
    );

    slide.nextLabel = <FormattedMessage {...messages.button_purchase} />;
    slide.onNext = () => this.processPayment();
    slide.prevLabel = <FormattedMessage {...messages.button_back} />;
    slide.onBack = () => this.cancelPayment();
    slide.skipClose = true;

    return slide;
  }

  renderApprovalSlide() {
    const { classes, settings } = this.props;

    let uppercase = settings.theme === HPX_THEME;

    let error = null;
    if (this.state.error) {
      error = (
        <p className={classes.modalText} style={{ textAlign: 'left', margin: '0.8rem 0', fontSize: '1rem', color: 'red' }}>
          {this.state.error}
        </p>
      );
    }

    let slide = {};

    slide.component = (
      <div>
        <p className={classes.modalHeader}>
          <FormattedMessage {...withValues(messages.kiosk_approval_form_header, { uppercase })} />
        </p>
        <p className={classes.modalText} style={{ textAlign: 'left', margin: '0.8rem 0', fontSize: '1rem' }}>
          <FormattedMessage {...messages.kiosk_approval_form_instructions} />
        </p>
        {error}
        <div className={classes.inputGroup}>
          <label className={classes.label} style={{ marginBottom: '0.2rem' }} for="pin">
            <FormattedMessage {...messages.form_label_pin} />
          </label>
          <input ref={this.pinInput} className={classes.input} type="password" name="pin" style={{ borderColor: '#aaa' }} />
        </div>
      </div>
    );

    slide.nextLabel = <FormattedMessage {...messages.button_approve} />;
    slide.onNext = () => this.authorizePin();
    slide.prevLabel = <FormattedMessage {...messages.button_edit_order} />;

    return slide;
  }

  renderAttendantSlide() {
    const { classes, settings, user } = this.props;

    const currencySign = getCurrencySign(settings.currency);
    const currencyOffset = currencySign.length > 1 ? '3rem' : '2rem';
    let currencyIcon;

    if (currencySign === '$') {
      currencyIcon = <AttachMoneyIcon style={{ position: 'absolute', top: '2.4rem', left: '0.5rem' }} />;
    } else {
      currencyIcon = <span style={{ position: 'absolute', top: '2.15rem', left: '0.75rem', fontWeight: 'bold', fontSize: '1.3rem' }}>{currencySign}</span>;
    }

    let uppercase = settings.theme === HPX_THEME;

    let error = null;
    if (this.state.error) {
      error = (
        <p className={classes.modalText} style={{ textAlign: 'left', margin: '0.8rem 0', fontSize: '1rem', color: 'red' }}>
          {this.state.error}
        </p>
      );
    }

    // unlock all checkbox only appears for Club Med for now.
    // hide after an unlock all purchase is made.
    // todo - make this a wheel setting
    let unlockCheckbox = null;
    if (settings.theme === CLUBMED_THEME && !user.unlocked) {
      unlockCheckbox = (
        <div className={classes.checkboxGroup}>
          <input ref={this.unlockCheckbox} className={classes.input} type="checkbox" name="unlock_all" style={{ float: 'left', width: 'auto', margin: '0.3rem 0.5rem 2rem 0.5rem' }} />
          <span style={{ float: 'left' }}>
            <FormattedMessage {...messages.form_label_unlock_all} />
          </span>
        </div>
      );
    }

    let slide = {};

    slide.component = (
      <div>
        <p className={classes.modalHeader}>
          <FormattedMessage {...withValues(messages.kiosk_approval_form_header, { uppercase })} />
        </p>
        <p className={classes.modalText} style={{ textAlign: 'left', margin: '0.8rem 0', fontSize: '1rem' }}>
          <FormattedMessage {...messages.kiosk_approval_form_instructions} />
        </p>
        {error}
        <div className={classes.inputGroup}>
          <label className={classes.label} style={{ marginBottom: '0.2rem' }} for="haggle_price">
            <FormattedMessage {...messages.form_label_price} values={{ currency: settings.currency }} />
          </label>
          <div style={{ position: 'relative' }}>
            {currencyIcon}
            <input ref={this.hagglePriceInput} className={classes.input} type="number" name="haggle_price" min="0" step="0.01" style={{ borderColor: '#aaa', paddingLeft: currencyOffset }} />
          </div>
        </div>
        {unlockCheckbox}
      </div>
    );

    slide.nextLabel = <FormattedMessage {...messages.button_approve} />;
    slide.onNext = () => this.approveHaggle();
    slide.prevLabel = <FormattedMessage {...messages.button_edit_order} />;

    return slide;
  }

  renderPaymentMethodSlide() {
    const { classes, settings } = this.props;

    let offsitePosBtn;
    switch (settings.offsite_pos_type) {
      case BILL_TO_ROOM_OFFSITE_POS_TYPE:
        offsitePosBtn = messages.button_bill_to_room;
        break;

      case GENERIC_OFFSITE_POS_TYPE:
      default:
        // if an offsite POS is offered as a payment method alongside Stripe,
        // then an offsite POS type should be implemented to provide better messaging.
        // right now the generic type works best when it's the only payment method
        offsitePosBtn = messages.button_complete_purchase;
    }

    let uppercase = settings.theme === HPX_THEME;

    let slide = {};

    slide.component = (
      <div className={classes.modalSlide}>
        <p className={classes.modalHeader}>
          <FormattedMessage {...withValues(messages.kiosk_payment_method_form_header, { uppercase })} />
        </p>
        <p className={classes.modalText} style={{ fontSize: '1rem', margin: '1rem 0' }}>
          <FormattedMessage {...messages.kiosk_payment_method_form_instructions} />
        </p>
      </div>
    );

    slide.buttons = []

    if (settings.stripe_reader_enabled) {
      slide.buttons.push(
        {
          nextLabel: <FormattedMessage {...messages.button_stripe_reader} />,
          onNext: () => this.selectStripeReaderCheckout()
        }
      );
    }

    if (settings.stripe_enabled) {
      slide.buttons.push(
        {
          nextLabel: <FormattedMessage {...messages.button_credit_or_debit_card} />,
          onNext: () => this.selectStripeCheckout()
        }
      );
    }

    if (settings.tilby_enabled) {
      slide.buttons.push(
        {
          nextLabel: <FormattedMessage {...messages.button_tilby} />,
          onNext: () => this.selectTilbyCheckout()
        }
      );
    }

    if (settings.offsite_pos_enabled) {
      slide.buttons.push(
        {
          nextLabel: <FormattedMessage {...offsitePosBtn} />,
          onNext: () => this.selectOffsitePosCheckout()
        }
      );
    }

    slide.prevLabel = <FormattedMessage {...messages.button_edit_order} />;

    return slide;
  }

  renderStripeCheckoutSlide() {
    const { classes, settings, user, purchaseRequest, calculations } = this.props;

    // may or may not exist
    let purchaseRequestId = purchaseRequest && purchaseRequest.id;

    let description = this.getPurchaseDescription();

    let freeMode = false;
    switch (settings.checkout_type) {
      case HAGGLE_CHECKOUT_TYPE:
        freeMode = purchaseRequest && purchaseRequest.amount === 0;
        break;

      case MARKETPLACE_CHECKOUT_TYPE:
        freeMode = calculations && calculations.total === 0;
    }

    let confirmEmailCallback = null;
    if (settings.enable_email_verification) {
      confirmEmailCallback = async () => {
        if (window.confirm(`Please confirm your email address is correct: ${this.props.email}. Click OK to continue or Cancel to change it.`)) {
          return Promise.resolve(true);
        } else {
          return Promise.resolve(false);
        }
      }
    }

    let stripeForm = (
      <StripeForm
        button={this.purchaseButton}
        requiredName={settings.set_mandatory_customer_name}
        processingText={"PURCHASING..."}
        email={this.purchaseEmail}
        name={this.customerName}
        accountId={settings.account_id}
        stripeKey={settings.stripe_key}
        callback={this.stripeCallback.bind(this)}
        kioskToken={settings.token}
        purchaseRequestId={purchaseRequestId}
        freeMode={freeMode}
        storyId={user.story_id}
        discountCode={calculations?.discount_coupon_code}
        description={description}
        confirmCallback={confirmEmailCallback}
      />
    );

    let cardLabel = null;
    if (!freeMode) {
      cardLabel = (
        <label className={classes.label} for="email">
          <FormattedMessage {...messages.form_label_credit_or_debit_card} />
        </label>
      );
    }

    let header, buttonsStyle = null;;
    if (settings.theme === CLUBMED_THEME) {
      header = messages.kiosk_stripe_form_header_clubmed;
      buttonsStyle = {
        marginTop: '1rem'
      }
    } else {
      header = messages.kiosk_stripe_form_header;
    }

    let uppercase = settings.theme === HPX_THEME;

    let slide = {};

    slide.component = (
      <div>
        <p className={classes.modalHeader} style={{ marginBottom: '1rem' }}>
          <FormattedMessage {...withValues(header, { uppercase })} />
        </p>
        <div style={{ margin: '0.5rem 0' }}>
          <PurchaseDetails condensed={true} hideHeader={true} />
        </div>
        <div className={classes.inputGroup}>
          <label className={classes.label} for="email">
            <FormattedMessage {...messages.form_label_email_address} />
          </label>
          <input ref={this.purchaseEmail} className={classes.input} type="email" name="email" defaultValue={this.props.email} />
        </div>
        <div className={classes.inputGroup}>
          {
            settings.set_mandatory_customer_name &&
            <div>
              <label className={classes.label} for='name'>
                <FormattedMessage {...messages.form_label_customers_name} />
              </label>
              <input ref={this.customerName} className={classes.input} style={{ marginBottom: '1rem' }} type="text" name="name" defaultValue={this.props.user.name} />
            </div>
          }
        </div>
        <div className={classes.inputGroup} style={{ height: '7.8rem' }}>
          {cardLabel}
          {stripeForm}
        </div>
      </div>
    );


    slide.nextLabel = <FormattedMessage {...messages.button_purchase} />;
    slide.prevLabel = <FormattedMessage {...messages.button_back} />;
    slide.skipClose = true;
    slide.nextRef = this.purchaseButton;
    return slide;
  }

  renderKioskPricingSlide() {
    const { kiosk_pricings, currency } = this.props.settings;
    let slide = { buttons: [] };

    for (let pricing of kiosk_pricings) {
      slide.buttons.push({
        nextLabel: (
          <span>
            <span style={{ fontWeight: 600 }}>
              {pricing.store_price}
              &nbsp;
              {currency}
              {pricing.description && " " + pricing.description}</span>
          </span>
        ),
        onNext: () => this.selectKioskPricing(pricing)
      }
      )
    }

    slide.prevLabel = <FormattedMessage {...messages.button_back} />;

    return slide;
  }

  renderTilbyCheckoutSlide() {
    // const { classes, settings, user, purchaseRequest, calculations } = this.props;
    const { classes, settings } = this.props;

    let slide = {};
    slide.component = (
      <div>
        <div className={classes.inputGroup}>
          <label className={classes.label} for="email">
            <FormattedMessage {...messages.form_label_email_address} />
          </label>
          <input ref={this.purchaseEmail} className={classes.input} type="email" name="email" defaultValue={this.props.email}
            disabled={(this.state.tilbyStatus === 'PROCESSING') ? "disabled" : ""}
          />
        </div>
        <div className={classes.inputGroup}>
          {
            settings.set_mandatory_customer_name &&
            <div>
              <label className={classes.label} for="name">
                <FormattedMessage {...messages.form_label_customers_name} />
              </label>
              <input ref={this.customerName} className={classes.input} style={{ marginBottom: '1rem' }} type="text" name="name" defaultValue={this.props.user.name} />
            </div>
          }
        </div>
        <div className={classes.inputGroup}>
          {this.state.error &&
            <p className={classes.modalText} style={{ textAlign: 'left', margin: '0.8rem 0', fontSize: '1rem', color: 'red' }}>
              {this.state.error}
            </p>
          }
          {
            this.state.tilbyStatus === 'PROCESSING' &&
            <p className={classes.modalText}>
              <FormattedMessage {...withValues(messages.kiosk_processing_payment)} />
            </p>
          }
        </div>
      </div>
    );

    // Call api that will create websocket for tilby
    slide.nextLabel = <FormattedMessage {...messages.button_purchase} />;
    slide.onNext = () => this.processTilby();
    slide.prevLabel = <FormattedMessage {...messages.button_back} />;
    slide.skipClose = true;

    return slide;
  }

  render() {
    const { classes, settings } = this.props;
    const { selectedPaymentMethod } = this.state;

    let slides = [];

    if (settings.checkout_type === HAGGLE_CHECKOUT_TYPE) {
      slides.push(this.renderApprovalSlide());
      slides.push(this.renderAttendantSlide());
    }

    if (settings.checkout_type === KIOSK_PRICING_CHECKOUT_TYPE) {
      slides.push(this.renderApprovalSlide());
      slides.push(this.renderKioskPricingSlide());
    }

    let paymentOptions = [settings.stripe_enabled, settings.offsite_pos_enabled, settings.stripe_reader_enabled, settings.tilby_enabled].filter(option => {
      return option
    });

    if (paymentOptions.length > 1) {
      slides.push(this.renderPaymentMethodSlide());

      switch (selectedPaymentMethod) {
        case STRIPE_PAYMENT_METHOD:
          slides.push(this.renderStripeCheckoutSlide());
          break;
        case OFFSITE_POS_PAYMENT_METHOD:
          slides.push(this.renderOffsitePosCheckoutSlide());
          break;
        case STRIPE_READER_PAYMENT_METHOD:
          slides.push(this.renderStripeReaderSlide());
          break;
        case TILBY_PAYMENT_METHOD:
          slides.push(this.renderTilbyCheckoutSlide());
          break;
        default:
      }

    } else if (settings.stripe_enabled) {
      slides.push(this.renderStripeCheckoutSlide());
    } else if (settings.offsite_pos_enabled) {
      slides.push(this.renderOffsitePosCheckoutSlide());
    } else if (settings.stripe_reader_enabled) {
      slides.push(this.renderStripeReaderSlide());
    } else if (settings.tilby_enabled) {
      slides.push(this.renderTilbyCheckoutSlide());
    }

    <ConfirmDialog />
    return <Modal slides={slides} open={this.props.open} onClose={() => this.onClose()} />;
  }
}

const mapStateToProps = state => ({
  settings: state.kioskReducer.settings,
  user: state.kioskReducer.user,
  moments: state.cartReducer.moments,
  selectedMomentIds: state.cartReducer.selectedMomentIds,
  selectedPrintMomentIds: state.cartReducer.selectedPrintMomentIds,
  combinedSelectedMomentIds: getCombinedSelectedMomentIds(state),
  email: state.kioskReducer.email,
  purchaseRequest: state.cartReducer.purchaseRequest,
  calculations: getSelectedCalculations(state),
  prints: getSelectedPrintMoments(state),
  locale: state.messagesReducer.locale,
  messages: state.messagesReducer.messages,
  connectionStatus: state.stripeReducer.connectionStatus,
  terminalPaymentData: state.stripeReducer.terminalPaymentData,
  stripeSettings: state.kioskReducer.stripeSettings,
  kioskPricings: state.kioskReducer.kioskPricings,
  defaultStripeReader: state.kioskReducer.defaultStripeReader
});

export default connect(mapStateToProps, { me, setEmail, authorizePin, updateReaderStatus, cancelStripeReader, processPaymentIntent, createPaymentIntent, createPurchaseRequest, setPurchased, addPurchase, viewReceipt, getPurchasedMomentIds, getPurchaseCalculations, createPaymentTilby, initWebhookTilby })(withStyles(styles)(PurchaseModal));
